module.exports = __webpack_public_path__ + "c4bcf3253ff5281ca8b0df5fbda10749.png";